import React from 'react'
import ReactPlayer from 'react-player'
import PropTypes from 'prop-types'

import * as styles from './VideoEmbed.styles.scss'

const VideoEmbed = ({
  isPlaying,
  hasControls,
  onEnded,
  onPause,
  src,
  config,
  width,
  height,
  isMuted,
  ...props
}) => {
  const handleOnEnd = () => {
    if (typeof onEnded === 'function') onEnded()
  }

  return (
    <div>
      <ReactPlayer
        className={styles.VideoEmbed}
        onEnded={handleOnEnd}
        onPause={onPause}
        url={src}
        playing={isPlaying}
        muted={isMuted}
        width={width}
        height={height}
        controls={hasControls}
        playsinline
        config={config}
        {...props}
      />
    </div>
  )
}

VideoEmbed.defaultProps = {
  hasControls: true,
  isPlaying: true,
  onEnded: () => {},
  onPause: () => {},
  config: {},
  width: '100%',
  height: 'auto',
  isMuted: false,
}

VideoEmbed.propTypes = {
  hasControls: PropTypes.bool,
  isPlaying: PropTypes.bool,
  onEnded: PropTypes.func,
  onPause: PropTypes.func,
  src: PropTypes.string,
  config: PropTypes.object,
}

export { VideoEmbed }
